import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=ddb3e686&scoped=true&"
import script from "./CV.vue?vue&type=script&lang=js&"
export * from "./CV.vue?vue&type=script&lang=js&"
import style0 from "./CV.vue?vue&type=style&index=0&id=ddb3e686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb3e686",
  null
  
)

export default component.exports